// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uvqK","input":"styles_input__lCmox"};